import React, { PropTypes, Component } from 'react';
import { connectToStores } from 'fluxible/addons';
import ProductEntity from '../components/ProductEntity';

class ProductEntityPage extends Component {
  static propTypes = {
    product: PropTypes.array.isRequired
  }

  static defaultProps = {
    product: []
  }

  render() {
    const product = this.props.product;
    return (
      <ProductEntity data={ product } />
      );
  }
}

ProductEntityPage = connectToStores(ProductEntityPage, ['ProductentityStore'], (stores, props) => {
  return {
    product: stores.ProductentityStore.get()
  };
});

export default ProductEntityPage;


// WEBPACK FOOTER //
// ./src/pages/ProductEntityPage.js